import React from "react"
import { Box, Typography } from "@mui/material"
import TextInput from "./TextInput"

const TextareaWithCharCount = ({
  maxLength,
  value = "",
  ...props
}) => {
  const charCount = value?.length || 0
  const isAtLimit = maxLength && charCount >= maxLength

  return (
    <Box sx={{ position: "relative", width: "100%" }}>
      <TextInput
        {...props}
        multiline
        inputProps={{
          maxLength,
          ...(props.inputProps || {}),
        }}
      />
      <Typography
        variant="caption"
        sx={{
          position: "absolute",
          bottom: 20,
          right: 12,
          color: isAtLimit ? "error.main" : "text.secondary",
          pointerEvents: "none",
        }}
      >
        {`${charCount}/${maxLength}`}
      </Typography>
    </Box>
  )
}

export default TextareaWithCharCount
